export const formatBalance = (balance: number) => {
  return (balance / 100).toLocaleString("en-GB", {
    style: "currency",
    currency: "GBP",
  });
};
